export default "__VITE_ASSET__DGj$dRyu__"